module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_05_6NV26_1SA_GSK.b0bc1702.png";